<template>
  <div>
    
    <div class="container">
        <div class="backWrap" >
           <span @click="goBack">
               &lt; 返回
           </span>
       </div>
        <div class="section">
            <h2 class="section-title">新增邀约</h2>
            <div>
                <h5 class="sub-tit">队员</h5>
                <div class="block">
                    <span class="label">姓名</span>
                    <input class="input" type="text"  placeholder="请输入邀请队员的姓名" v-model="memberInfo.userRealname">
                </div>
                <div class="block">
                    <span class="label">手机号</span>
                    <input class="input" type="tel" maxlength="11"  placeholder="请输入邀请队员的手机号" v-model="memberInfo.phone">
                </div>
                <div class="block">
                    <span class="label">身份证</span>
                    <input class="input" placeholder="请输入邀请队员的身份证号" v-model="memberInfo.userIdNumber">
                </div>
            </div>

            <div class="add-invite">
                <span class="add-btn" @click="invite">确认邀约</span>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
 import {newlyInvitation} from '@/api/index' //新增邀约
 import { validateMobile, validateIdCard } from '@/utils/validate'
export default {
  name: 'index',
  data () {
    return {
        memberInfo:{
            userRealname:"",
            phone:"",
            userIdNumber:"",
        },
    }
  },
  computed: {

  },
  created () {

  },
  mounted() {

  },
  methods: {
      check(){
        let _this=this
        if(!_this.memberInfo.userRealname){
            this.$cToast('请输入被邀请人的姓名')
            return false
        } 
        if(!_this.memberInfo.phone){
             this.$cToast('请输入被邀请人的手机号')
             return false
        } 
        if(!_this.memberInfo.userIdNumber){
             this.$cToast('请输入被邀请人的身份证号')
             return false
        } 
        if(!validateMobile(_this.memberInfo.phone)){
             this.$cToast('手机号格式不正确')
             return false
        }
        if(!validateIdCard(_this.memberInfo.userIdNumber).pass){
             this.$cToast('身份证号不正确')
             return false
        }
        return true
      },
      invite(list){//邀约
          let _this=this
          if(_this.check()){
              newlyInvitation(_this.memberInfo).then((res) => {
                  if (res.errorCode == 200) {
                      this.$createToast({
                      	txt: '邀约成功',
                      	type: 'txt'
                      }).show()
                  } else {
                      this.$createToast({
                      	txt: res.errorMsg,
                      	type: 'txt'
                      }).show()
                  }
              }).catch(err => {})
          }
          
      },
    goBack() {
        this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .backWrap{
      font-size: 0.35rem;padding: 0.3rem 0.4rem; letter-spacing: 1px; font-weight: bold;
  }
  .container {padding: 0.4rem 0 0.3rem;}
  .section {padding: 0 0.4rem 0.8rem;}
  .section-title { padding: 0.2rem 0 0.6rem; font-size: 0.4rem; color: #333;}

  .add-invite {padding: 1rem 0;}
  .add-invite .add-btn {color: #fff; background: #df7a32; border-radius: 0.1rem; width: 1.6rem; height: 0.6rem; line-height: 0.6rem;
   text-align: center; margin: 0 auto; display: block;}
    .sub-tit {
        color: #dc8035;
        font-size: 0.3rem;
    }
    .block {
        position: relative;
        min-height: 0.5rem;
        padding-left: 1.7rem;
        padding-top: 0.5rem;
        box-sizing: border-box;
    }

    .label {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 1.4rem;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.32rem;
        color: #333;
        overflow: hidden;
        text-align: justify;
        font-weight: bold;
    }
    .label::after{
        content: ' ';
        display: inline-block;
        width:100%;
        height:0;
    }

    .input {
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.32rem;
        color: #333;
        padding: 0;
        margin: 0;
        background: transparent;
        width: 100%;
        border: none;
        border-bottom: 1px solid #a1a1a1;
        outline: none;
        text-align: 0.2rem;
    }
</style>

